'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDomServer = require('react-dom/server');

var _reactDomServer2 = _interopRequireDefault(_reactDomServer);

var _nodeUuid = require('node-uuid');

var _nodeUuid2 = _interopRequireDefault(_nodeUuid);

var _session = require('./session');

var _session2 = _interopRequireDefault(_session);

var _transaction = require('./transaction');

var _transaction2 = _interopRequireDefault(_transaction);

/*******************************************************************************
 * Create a new render context. This is to hold all of our queries in place
 * so that we can send them down the wire to the client.
 */
function createRenderContext(session) {
	return {
		$QUERY_SESSION: session || new _session2['default']()
	};
}

/*******************************************************************************
 * Instantiate an element
 */
function createElementInstance(elem) {
	var ctx = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	if (!elem) {
		return null;
	}

	if (typeof elem === 'string' || typeof elem.type === 'string' || typeof elem === 'number' || typeof elem.type !== 'function') {
		return elem;
	}

	var props = elem._store && elem._store.props ? elem._store.props : elem.props;
	var node = null;

	_session2['default'].bind(ctx.$QUERY_SESSION, function () {
		node = new elem.type(props, ctx);
	});

	return node;
}

/*******************************************************************************
 * Get a list of children
 */
function collect(element) {
	var collection = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];

	collection.push(element);
	if (element && element.props && Array.isArray(element.props.children)) {
		element.props.children.forEach(function (child) {
			return collect(child, collection);
		});
	}
	return collection;
}

/*******************************************************************************
 * Render an element instance and return the set of children
 */
function renderElementInstance(inst) {
	if (inst && typeof inst.render === 'function') {
		return collect(inst.render());
	} else if (Array.isArray(inst)) {
		return inst.map(function (i) {
			return renderElementInstance(i);
		});
	} else if (Object(inst) === inst) {
		var children = inst.props.children;
		if (Array.isArray(children)) {
			return children;
		} else {
			return [children];
		}
	}
	return [];
}

/*******************************************************************************
 * The walk method is what we will call recursively until we have nothing
 * left to render and no queries to run.
 */
function walk(element, ctx) {
	return new Promise(function (resolve, reject) {
		var instance = createElementInstance(element, ctx);
		var children = renderElementInstance(instance);
		var session = ctx.$QUERY_SESSION;
		var transactions = session.transactions.filter(function (tx) {
			return tx.mode === _transaction2['default'].Mode.BLOCKING;
		}).map(function (tx) {
			return tx.asPromise();
		});

		Promise.all(transactions).then(function () {
			Promise.all(children.map(function (child) {
				return walk(child, ctx);
			})).then(resolve)['catch'](reject);
		})['catch'](reject);
	});
}

/*******************************************************************************
 * Our custom render method is where the magic happens. Our custom render
 * method handles instantiation and lifecycle of components.
 *
 * This will actually render the page twice, but only twice regardless of
 * the number of queries as we will pause a components render() method
 * until its data dependencies have been satisfied.
 */
function render(element, reactRenderMethod) {
	var options = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];

	return new Promise(function (resolve, reject) {
		try {
			(function () {
				var session = options.session || new _session2['default']();
				var ctx = createRenderContext(session);

				walk(element, ctx).then(function (result) {
					var markup = '';

					_session2['default'].bind(session, function () {
						markup = reactRenderMethod(element);
					});

					resolve({ markup: markup, session: session });
				})['catch'](reject);
			})();
		} catch (e) {
			reject(e);
		}
	});
}

/*******************************************************************************
 * Export our two convenience methods
 */
exports['default'] = {
	toString: function toString(element, options) {
		return render(element, _reactDomServer2['default'].renderToString, options);
	},

	toStaticMarkup: function toStaticMarkup(element, options) {
		return render(element, _reactDomServer2['default'].toStaticMarkup, options);
	}
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/acast-reactor/dist/render.js
// module id = BxOW
// module chunks = 15